import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { withRouter } from '../../../util/withRouter';
import { Button } from 'react-bootstrap';

import Confirm from '../../../components/Confirm/Confirm';
import Loading from '../../../components/Loading/Loading';

import { getViews } from '../../Wallboards/WallboardsActions';
import ForecastingConfig from '../components/ForecastingConfig';
import { getForecastings, deleteForecasting } from '../ForecastingActions';

import addIcon from '../../../assets/img/add-circle.svg';
import deleteIcon from '../../../assets/img/delete.svg';
import editIcon from '../../../assets/img/edit.svg';
import openInNewIcon from '../../../assets/img/open-in-new.svg';

import '../Forecasting.scss';

class AllForecasts extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: ''
    };
  }

  componentDidMount() {
    if (this.props.routeParams.dashboardId) {
      this.props.getViews(this.props.routeParams.dashboardId);
      this.getForecastings();
    } else {
      this.props.router.push(
        `/dashboard${!!this.props.routeParams.dashboardId ? `/${this.props.routeParams.dashboardId}` : ''}`
      );
    }
  }

  getForecastings = () => {
    this.props.getForecastings(this.props.routeParams.dashboardId);
  };

  onSearch = e => {
    this.setState({ search: e.target.value });
  };

  onDelete = id => {
    this.props.deleteForecasting(id, this.props.routeParams.dashboardId).then(() => {
      this.getForecastings();
    });
  };

  renderViewValue = value => {
    let option = _.find(this.props.views, { _id: value });
    if (option) {
      return option.name;
    }
    option = _.find(this.props.views, { _id: 'default' });
    if (option) {
      return option.name;
    }
  };

  render() {
    const { forecasts, isLoading } = this.props;

    return (
      <React.Fragment>        
        <div key="2" id="create-account" className='bg_dashboard'>
          <Helmet>
            <title>{pageTitle(`Continuous Forecasts`)}</title>
          </Helmet>
          <div className='user_container'>
            <ForecastingConfig dashboardId={this.props.routeParams.dashboardId} onClose={this.getForecastings}>
              <Button className='btn-align-right'>
                <img src={addIcon} alt="" /> Create new
              </Button>
            </ForecastingConfig>
            
            <div className='table-content'>
              {!isLoading && !forecasts.length && (
                <div className='no-data'>
                  <div> No data available </div>
                </div>
              )}
              <div className='table-filter'>
                <div></div>
                <div className="u-di form-group">
                  <div className='search-wrap'>
                    <input
                      name="search"
                      placeholder="Search"
                      type="text"
                      id="Search"
                      className="form-control"
                      value={this.state.search}
                      onChange={this.onSearch}
                    />
                  </div>
                </div>
              </div>

              <div className='table-scroll'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Start date</th>
                      <th>Target date</th>
                      <th>Percentile</th>
                      <th>View</th>
                      <th className="width-auto">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {forecasts.map((f, i) => {
                      return (
                        <tr key={i} className='row-item'>
                          <td>{f.name}</td>
                          <td>{moment(f.startDate).format('D MMM YYYY')}</td>
                          <td>{f.targetDate ? moment(f.targetDate).format('D MMM YYYY') : '-'}</td>
                          <td>{f.percentile}%</td>
                          <td>{this.renderViewValue(f.selectedView)}</td>
                          <td className="width-auto">
                            <div className='flex'>
                              <Button variant='secondary' size='md' className='btn-mw-100' onClick={() => { window.open(f.url, '_blank') }}>
                                <img src={openInNewIcon} alt="" />
                                Open
                              </Button>

                              <ForecastingConfig
                                dashboardId={this.props.routeParams.dashboardId}
                                model={f}
                                onClose={this.getForecastings}>
                                <Button variant='secondary' size='md' className='btn-mw-100'>
                                  <img src={editIcon} alt="" /> Edit
                                </Button>
                              </ForecastingConfig>
                              
                              <Confirm
                                onConfirm={() => this.onDelete(f._id)}
                                body={
                                  <p>
                                    Are you sure you want to remove <br />
                                    <strong>{f.name}</strong> continuous forecasting?
                                  </p>
                                }
                                confirmText="Remove"
                                icon={deleteIcon}
                                title="Remove forecast"
                              >
                                <Button variant='danger' size='md' className='btn-icon'>
                                  <img src={deleteIcon} alt="delete" />
                                </Button>
                              </Confirm>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {isLoading && (
          <div className='table-loading loader-delay'>
            <Loading />
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getViews: dashboardId => dispatch(getViews(dashboardId)),
    getForecastings: dashboardId => dispatch(getForecastings(dashboardId)),
    deleteForecasting: (id, dashboardId) => dispatch(deleteForecasting(id, dashboardId))
  };
};

const mapStateToProps = state => {
  return {
    views: state.wallboards.views,
    forecasts: state.forecasting.forecasts,
    isLoading: state.forecasting.loading
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AllForecasts));
